<template>
  <a-row :gutter="24">
    <!-- 部门树 -->
    <a-col :md="6" :sm="24">
      <dept-tree @select="treeSelect"></dept-tree>
    </a-col>
    <!-- manager -->
    <a-col :md="18" :sm="24">
      <a-card :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" :form="form">
            <a-row :gutter="24">
              <a-col :md="8" :sm="24">
                <a-form-item label="姓名">
                  <a-input v-decorator="['name']" placeholder="请输入姓名" />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="工号">
                  <a-input v-decorator="['empCode']" placeholder="请输入工号" />
                </a-form-item>
              </a-col>
              <template v-if="expand">
                <a-col :md="8" :sm="24">
                  <a-form-item label="手机">
                    <a-input
                      v-decorator="['mobile']"
                      placeholder="请输入手机"
                    />
                  </a-form-item>
                </a-col>
                <!-- <a-col :md="8" :sm="24">
                  <a-form-item label="邮箱">
                    <a-input v-decorator="['email']" placeholder="请输入邮箱" />
                  </a-form-item>
                </a-col> -->
                <!-- <a-col :md="8" :sm="24">
                  <a-form-item label="部门">
                    <a-input
                      v-decorator="['deptName']"
                      placeholder="请输入部门名称"
                    />
                  </a-form-item>
                </a-col> -->
              </template>
              <a-col
                :md="(!expand && 8) || 24"
                :sm="24"
                :style="{ textAlign: expand ? 'right' : 'left' }"
              >
                <a-button type="primary" icon="search" @click="handleSearch"
                  >查询
                </a-button>
                <a-button
                  icon="redo"
                  style="margin-left: 8px"
                  @click="handleReset"
                  >重置
                </a-button>
                <a
                  :style="{ marginLeft: '8px', fontSize: '12px' }"
                  @click="toggle"
                >
                  高级搜索
                  <a-icon :type="expand ? 'up' : 'down'" />
                </a>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <div class="table-operator">
          <a-button type="primary" icon="plus" @click="handleEdit()"
            >新增
          </a-button>
          <!--          <a-button type="primary" icon="import" @click="handleImport"-->
          <!--            >导入-->
          <!--          </a-button>-->
          <!--          <a-button type="primary" icon="export" @click="handleExport"-->
          <!--            >导出-->
          <!--          </a-button>-->
        </div>

        <s-table
          ref="table"
          size="default"
          rowKey="id"
          :columns="columns"
          :data="loadData"
          :alert="true"
          :rowSelection="rowSelection"
          showPagination="auto"
        >
          <span slot="serial" slot-scope="text, record, index">
            {{ index + 1 }}
          </span>

          <span slot="action" slot-scope="text, record">
            <template>
              <a @click="handleEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a @click="changePassword(record)">密码</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="handleDel(record)">删除</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </span>
        </s-table>
      </a-card>
    </a-col>
    <!-- 新增编辑页面 -->
    <user-drawer ref="UserDrawer" @ok="EditSubmitSuccess"></user-drawer>
    <!-- 修改密码页面 -->
    <user-password ref="PassWordModal" @ok="EditSubmitSuccess" />
  </a-row>
</template>

<script>
import { STable } from "@/components";
import DeptTree from "./modules/DeptTree";
import UserDrawer from "./modules/UserDrawer";
import UserPassword from "./modules/UserResetPwd";

import { findPage, del } from "@/api/system/user";

// table数据模拟 start
const columns = [
  {
    title: "#",
    scopedSlots: { customRender: "serial" }
  },
  {
    title: "姓名",
    dataIndex: "name"
  },
  {
    title: "工号",
    dataIndex: "empCode"
  },
  {
    title: "性别",
    dataIndex: "sex",
    customRender: text => (text == "M" ? "男" : "女")
  },
  {
    title: "手机号码",
    dataIndex: "mobile"
  },
  {
    title: "状态",
    dataIndex: "status",
    customRender: text => (text == "A" ? "正常" : "禁用")
  },
  {
    title: "操作",
    dataIndex: "action",
    width: "150px",
    scopedSlots: { customRender: "action" }
  }
];
// end
export default {
  components: {
    STable,
    DeptTree,
    UserDrawer,
    UserPassword
  },
  data() {
    this.columns = columns;
    return {
      form: this.$form.createForm(this, { name: "user_search" }),
      // 高级搜索 展开/关闭
      expand: false,
      // 查询参数
      queryParam: {},
      // 加载数据方法 必须为 Promise 对象
      loadData: params => {
        const requestParameters = Object.assign(params, this.queryParam);
        return findPage(requestParameters).then(res => {
          return res;
        });
      },
      selectedRowKeys: [],
      selectedRows: []
    };
  },
  computed: {
    count() {
      return this.expand ? 20 : 3;
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange
      };
    }
  },
  methods: {
    //部门树选择触发事件
    treeSelect(val) {
      console.log("treeSelect", val);
      this.queryParam = { deptId: val.key };
      this.$refs.table.refresh(true);
    },
    // 查询触发事件
    handleSearch() {
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          this.queryParam = Object.assign(this.queryParam, values);
          this.$refs.table.refresh(true);
        }
      });
    },
    // 重置
    handleReset() {
      this.form.resetFields();
    },
    // 高级搜索
    toggle() {
      this.expand = !this.expand;
    },
    // 导入
    handleImport(e) {
      console.log("handleImport", e);
    },
    // 导出
    handleExport(e) {
      console.log("handleExport", e);
    },
    // grid选择改变时触发事件
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    //新增编辑页面
    handleEdit(record) {
      this.$refs.UserDrawer.edit(record);
      this.$refs.UserDrawer.title = "详情";
    },
    changePassword(record) {
      this.$refs.PassWordModal.showModal(record.id);
    },
    handleDel(record) {
      let that = this;
      let params = { userIdStrs: record.id, status: "D" };
      this.$confirm({
        title: "提示",
        content: "确认删除该条数据吗?",
        onOk() {
          del({ ...params }).then(res => {
            if (res.resultCode === 1) {
              that.$notification.success({
                message: res.message
              });
            } else {
              that.$notification.error({
                message: res.message
              });
            }
            that.EditSubmitSuccess();
          });
        }
      });
    },
    //新增编辑页面提交事件
    EditSubmitSuccess() {
      this.$refs.table.refresh(true);
    }
  },
  filters: {}
};
</script>

<style></style>
